export default {
  placement: 'ELIGIBILITY',
  tagMaropost: 'Eligibility',
  product: 'STM'
}
